/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum DisplayDeviceUsage {
    Unused = 0,
    Debriefing = 10,
    Presentation = 11,
    Training = 12,
    FloorScreen = 100,
    RoomStateScreen = 110,
}
